// Cadastrar fonte.
//
// Faltava, e a falta só apareceu quando o back office subiu com o banco vazio:
// a tela de Fontes sabia **editar** e não sabia **criar**, então não havia como
// começar. Sem fonte não há camada, e sem camada não há nada.
//
// Órgão e URL oficial são os únicos campos obrigatórios. **Licença e atribuição
// ficam de fora de propósito**: uma fonte recém-cadastrada normalmente ainda
// não teve a licença decidida, e exigi-las aqui empurraria quem cadastra a
// inventar um valor — que é o risco que o ADR-008 existe para evitar. O gate
// continua na publicação, e é do banco.

import { useState, type ReactNode } from "react";
import { Gaveta } from "../pecas/basicos.js";

export function NovaFonte({
  aoFechar,
  aoSalvar,
  salvando,
}: {
  aoFechar: () => void;
  aoSalvar: (corpo: Record<string, unknown>) => void;
  salvando: boolean;
}): ReactNode {
  const [orgao, setOrgao] = useState("");
  const [url, setUrl] = useState("");
  const [licenca, setLicenca] = useState("");
  const [atribuicao, setAtribuicao] = useState("");
  const [pessoal, setPessoal] = useState(false);
  const [contorno, setContorno] = useState(false);

  const pronto = orgao.trim() !== "" && url.trim() !== "";
  const publicavel = licenca.trim() !== "" && atribuicao.trim() !== "";

  return (
    <Gaveta titulo="Nova fonte" subtitulo="procedência, licença e restrição" aoFechar={aoFechar}>
      <div className="form-secao">
        <div className="form-secao-titulo">Identificação</div>
        <div className="campo">
          <label htmlFor="orgao">Órgão</label>
          <input
            id="orgao"
            value={orgao}
            placeholder="INCRA, IBGE, SICAR…"
            onChange={(e) => setOrgao(e.target.value)}
          />
        </div>
        <div className="campo">
          <label htmlFor="url">URL oficial</label>
          <input
            id="url"
            value={url}
            placeholder="https://…"
            onChange={(e) => setUrl(e.target.value)}
          />
          <div className="campo-ajuda">
            A página ou serviço do órgão — não o endpoint da camada.
          </div>
        </div>
      </div>

      <div className="form-secao">
        <div className="form-secao-titulo">Procedência</div>
        <div className="campo">
          <label htmlFor="nova-licenca">Licença</label>
          <input
            id="nova-licenca"
            value={licenca}
            placeholder="CC-BY-4.0, Dados Abertos, Termo de uso do órgão…"
            onChange={(e) => setLicenca(e.target.value)}
          />
        </div>
        <div className="campo">
          <label htmlFor="nova-atribuicao">Atribuição</label>
          <input
            id="nova-atribuicao"
            value={atribuicao}
            placeholder="como o crédito deve aparecer para o cliente"
            onChange={(e) => setAtribuicao(e.target.value)}
          />
          {/* O aviso reage ao que foi preenchido, em vez de repetir a regra:
              ler "não publicável" com os campos vazios diz mais que um
              parágrafo explicando quando ela vale. */}
          <div className={`campo-ajuda ${publicavel ? "" : "campo-ajuda-atencao"}`}>
            {publicavel
              ? "Com as duas, coleções desta fonte podem ser publicadas."
              : "Sem as duas a fonte fica não publicável: curar pode, publicar não. Preencher por palpite é o risco que o registro existe para evitar."}
          </div>
        </div>
      </div>

      <div className="form-secao">
        <div className="form-secao-titulo">Declarações</div>
        <label className="opcao">
          <input type="checkbox" checked={pessoal} onChange={(e) => setPessoal(e.target.checked)} />
          <span>
            Contém dado pessoal
            <div className="campo-ajuda">
              LGPD: os atributos marcados serão suprimidos na publicação.
            </div>
          </span>
        </label>
        <label className="opcao">
          <input
            type="checkbox"
            checked={contorno}
            onChange={(e) => setContorno(e.target.checked)}
          />
          <span>
            Exige contorno de bloqueio para ser obtida
            <div className="campo-ajuda">
              Fonte que só responde a User-Agent de navegador ou RPA (ADR-008).
            </div>
          </span>
        </label>
      </div>

      <div className="acoes-form">
        <button
          className="btn btn-primario"
          disabled={!pronto || salvando}
          onClick={() =>
            aoSalvar({
              orgao: orgao.trim(),
              url_oficial: url.trim(),
              licenca: licenca.trim() || null,
              atribuicao: atribuicao.trim() || null,
              contem_dado_pessoal: pessoal,
              exige_contorno: contorno,
            })
          }
        >
          {salvando ? "Criando…" : "Criar fonte"}
        </button>
        <button className="btn" onClick={aoFechar}>
          Cancelar
        </button>
      </div>
    </Gaveta>
  );
}
